import type { Components, Theme } from '@mui/material';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    inputRoot: ({ ownerState }) => ({
      ...(ownerState.multiple && {
        height: 'auto',
        minHeight: 40,
      }),
    }),
  },
};
